import axios from 'axios';

// 创建 Axios 实例
const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/api', // 统一接口前缀（可在 .env 配置）
  timeout: 10000, // 超时时间
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); // 从 localStorage 读取 Token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // 在请求头携带 Token
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response) {
      const status = error.response.status;
    }
    return Promise.reject(error);
  }
);

// 封装 GET/POST/PUT/DELETE 方法
const request = {
  get: (url, params) => instance.get(url, { params }),
  post: (url, data, config) => instance.post(url, data, config),
  put: (url, data) => instance.put(url, data),
  delete: (url) => instance.delete(url),
};

export default request;
